import { AuthAction, AuthActionTypes, IAuthState } from '../../../types/auth'
import {
	ROOT_REDUCER_ACTION_TYPES,
	RootReducerResetAction,
} from '../../../types/rootStoreTypes'

export const initialState: IAuthState = {
	auth: !!localStorage.getItem('access_token'),
	mfaRequiredError: null,
	mfaRequiredErrorDescription: null,
	mfaToken: null,
	authenticators: [],
	oobChannel: '',
	oobCode: '',
	loading: false,
	accessToken: localStorage.getItem('access_token') || '',
	skipMfa: true,
}

export default (
	state = initialState,
	action: AuthAction | RootReducerResetAction
): IAuthState => {
	switch (action.type) {
		case AuthActionTypes.AUTH_LOGIN: {
			const accessToken = action.payload

			return {
				...state,
				accessToken,
				auth: !!accessToken,
			}
		}

		case AuthActionTypes.AUTH_MFA_REQUIRED_ERROR: {
			return {
				...state,
				...action.payload,
			}
		}

		case AuthActionTypes.AUTH_LOADING: {
			return {
				...state,
				loading: action.payload,
			}
		}

		case AuthActionTypes.AUTH_SET_MFA_TOKEN: {
			return {
				...state,
				mfaToken: action.payload,
			}
		}

		case AuthActionTypes.AUTH_SET_AUTHENTICATORS: {
			return {
				...state,
				authenticators: action.payload,
			}
		}

		case AuthActionTypes.AUTH_SET_OOB_CHANNEL: {
			return {
				...state,
				oobChannel: action.payload,
			}
		}

		case AuthActionTypes.AUTH_SET_OOB_CODE: {
			return {
				...state,
				oobCode: action.payload,
			}
		}

		case AuthActionTypes.AUTH_SET_SKIP_MFA_AUTH: {
			return {
				...state,
				skipMfa: action.payload,
			}
		}

		case ROOT_REDUCER_ACTION_TYPES.ROOT_REDUCER_RESET: {
			if (localStorage.getItem('access_token')) {
				localStorage.removeItem('access_token')
			}

			return {
				...initialState,
				auth: false,
				accessToken: '',
			}
		}

		default:
			return state
	}
}
